module.exports = __webpack_public_path__ + "img/undraw_creative_team.bacef204.png";